/**
 * @module events/types/focusIn
 */

/**
 * @type {string}
 */
export default 'focusin'
